import * as EnvheavenEnvironmentVarsProvider from "./envheaven-environment-vars-provider";

export interface EnvVarsData {
  ENVIRONMENT_MAP_INTERNAL_ID: string;
  ENVIRONMENT_MAP_PUBLIC_NAME: string;
  ENVIRONMENT_NAME: string;

  IS_PRODUCTION: boolean;
  IS_BETA: boolean;
  IS_DEVELOPMENT: boolean;
  IS_LOCAL: boolean;
  IS_FAKE_SHOWCASE: boolean;

  AH_DASH_FE_02_PUBLIC_NAME: string;
  AH_DASH_FE_02_INTERNAL_ID: string;
  AH_DASH_FE_02_FULL_URL: string;
  AH_DASH_FE_02_IP_ADDRESS: string;
  AH_DASH_FE_02_PORT: string;
  AH_DASH_FE_02_VERSION: string;

  AH_DASH_API_SERVER_01_PUBLIC_NAME: string;
  AH_DASH_API_SERVER_01_INTERNAL_ID: string;
  AH_DASH_API_SERVER_01_FULL_URL: string;
  AH_DASH_API_SERVER_01_IP_ADDRESS: string;
  AH_DASH_API_SERVER_01_PORT: string;
  AH_DASH_API_SERVER_01_VERSION: string;

  AH_DASH_FE_CDN_01_PUBLIC_NAME: string;
  AH_DASH_FE_CDN_01_INTERNAL_ID: string;
  AH_DASH_FE_CDN_01_FULL_URL: string;
  AH_DASH_FE_CDN_01_IP_ADDRESS: string;
  AH_DASH_FE_CDN_01_PORT: string;
  AH_DASH_FE_CDN_01_VERSION: string;
}

export const environment: EnvVarsData =
  EnvheavenEnvironmentVarsProvider.GetEnvVars<EnvVarsData>();

export class AppEnvironmentHandler {
  static IsProd(): boolean {
    return environment.IS_PRODUCTION;
  }

  static IsLocal(): boolean {
    return environment.IS_LOCAL;
  }
}
